import script from "./AlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertModal.vue?vue&type=script&setup=true&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=1e9bc2aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9bc2aa"]])

export default __exports__